import Vue from 'vue';
import VueMeta from 'vue-meta';
// import anime from 'animejs/lib/anime.es.js'
import Hammer from 'hammerjs';
// import { v4 as uuid } from 'uuid';
import { nanoid } from 'nanoid';
/** lodash */
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import upperFirst from 'lodash/upperFirst';
import find from 'lodash/find';
import findKey from 'lodash/findKey';
import merge from 'lodash/merge';
import xor from 'lodash/xor';
import setWith from 'lodash/setWith';
import get from 'lodash/get';
import unionBy from 'lodash/unionBy';
import pickBy from 'lodash/pickBy';
import cloneDeep from 'lodash/cloneDeep';
import moment from '@/vendors/moment';
import Vuelidate from 'vuelidate';
import Cookies from 'js-cookie';
import {
  scroll,
  resize,
  clickOutside,
  orientation,
  collapse,
  smoothHeight,
} from '@/directives';
import { arrToSrcset } from '@/common/common';
import { axiosInstance } from '@/api';
import WebAppAPIService from '@/services/WebappAPIService';
import WPAPIService from '@/services/WPAPIService';
import configEnv from '@/enums/configEnv';
import App from './App.vue';
import router from './router';
import store from './store';
import LogService from '@/services/LogService';

if (!configEnv.nodeEnv) {
  throw new Error('NODE_ENV is not defined');
}
if (!configEnv.server_type) {
  throw new Error('VUE_APP_SERVER_VERSION is not defined');
}
if (!configEnv.serverApi) {
  LogService.error('VUE_APP_API_SERVER missing in env');
}
if (!configEnv.apiKey) {
  LogService.error('VUE_APP_API_KEY missing in env');
}
if (!configEnv.wpApiServer) {
  LogService.error('VUE_APP_WP_API_SERVER missing in env');
}
if (!configEnv.gapiKey) {
  LogService.error('VUE_APP_GAPI_KEY missing in env');
}

// externes Cookie-Consent Skript laden
const script = document.createElement('script');
script.src = 'https://www.freeprivacypolicy.com/public/cookie-consent/4.0.0/cookie-consent.js';
script.charset = 'UTF-8';
script.onload = () => {
  // cookieconsent ist jetzt verfügbar
  const mobile = window.innerHeight / window.innerWidth > 1;
  const bannerType = mobile ? 'headline' : 'simple';

  // eslint-disable-next-line no-undef
  cookieconsent.run({
    notice_banner_type: bannerType,
    consent_type: 'standalone',
    palette: 'light',
    language: configEnv.default_language,
    page_load_consent_levels: ['strictly-necessary'],
    notice_banner_reject_button_hide: false,
    preferences_center_close_button_hide: false,
    page_refresh_confirmation_buttons: false,
    website_name: 'Wetterheld',
    website_privacy_policy_url: 'https://wetterheld.com/home/blog/Wetterheld_PrivacyPolicy.pdf',
  });
};
document.head.appendChild(script);

const server = configEnv.serverEnv;
const version = configEnv.server_type;

let gtmId = null;
if (server === 'production' && version === 'Wetterheld') {
  gtmId = 'GTM-T4R4T83';
} else if (server === 'test' && version === 'Wetterheld') {
  gtmId = 'GTM-TLTVZMT';
}

if (gtmId) {
  const scriptGoogle = document.createElement('script');
  scriptGoogle.type = 'text/plain';
  scriptGoogle.setAttribute('cookie-consent', 'tracking');
  scriptGoogle.innerHTML = `(function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${gtmId}');`;
  document.head.appendChild(scriptGoogle);
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noscript, document.body.firstChild);
}

Vue.config.productionTip = false;

// prototype section
Vue.prototype.$lodash = {
  debounce,
  isEqual,
  upperFirst,
  find,
  findKey,
  merge,
  xor,
  setWith,
  get,
  unionBy,
  cloneDeep,
  pickBy,
};
// Vue.prototype.$anime = anime
Vue.prototype.$hammer = Hammer;
Vue.prototype.$uuid = nanoid;
Vue.prototype.$axios = axiosInstance;
Vue.prototype.$webAppAPI = new WebAppAPIService(store);
Vue.prototype.$wpAPI = new WPAPIService(axiosInstance, store);
Vue.prototype.$moment = moment;
Vue.prototype.$arrToSrcset = arrToSrcset;
Vue.prototype.$Cookies = Cookies;

// components
Vue.component('datepickerComponent', () => import(/* webpackChunkName: "Datepicker" */ '@/components/datepicker/DatePicker.vue'));
Vue.component('wetModal', () => import(/* webpackChunkName: "wet-modal" */ '@/components/wetModal.vue'));
Vue.component('accordeonComponent', () => import(/* webpackChunkName: "accordeon" */ '@/components/accordeonComponent.vue'));

// use section
Vue.use(VueMeta);
Vue.use(Vuelidate);

// directives
Vue.directive('scroll', scroll);
Vue.directive('resize', resize);
Vue.directive('click-outside', clickOutside);
Vue.directive('orientation', orientation);
Vue.directive('collapse', collapse);
Vue.directive('smooth-height', smoothHeight);

// iframe reizer
require('iframe-resizer/js/iframeResizer.contentWindow');

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
